import React, { useState } from "react";
import { Link } from "react-router-dom";
import Pending from "../../../../assets/images/pending 2.png";
import LiN from "../../../../assets/images/Rounds/statusTopBanner.png";
import "./PendingPost.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AllDataHeader from "../../../Reuseable/AllDataHeader";
const PendingPostStar = () => {
  return (
    <>
      <div className=" row ">
        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img src={Pending} className="ad-card-img-top" alt="..." />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small"></small>

                    <small className="ad-card-small">03</small>
                  </td>
                </tr>
              </center>
            </div>
            {/* <Link to="/superstar/audition/live"> */}
            <button
              className="card-footer Souvenir-button  w-100 "
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {" "}
              Pending Audition Post
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>

      <div className="my-3">
        <AllDataHeader
          title="Pending Auditions"
          image={Pending}
          count={"Zero"}
        />
      </div>

      <div className="row">
        <div className="clo-sm-12 col-md-6 col-lg-3 mb-3">
          <div className="sliderCardBorder">
            <img
              src={LiN}
              className="img-fluid"
              alt=""
              style={{ height: "200px", width: "100%" }}
            />
            <div className="p-3">
              <h5 className="text-white text-center title-limit">
                Audition Post sad..
              </h5>

              <p className="text-secondary">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Distinctio
              </p>
              <Link
                to="/superstar/audition/pending-post-details"
                className="Link"
              >
                <button className="btn btn-done w-100 fw-bold mt-2">
                  Action
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingPostStar;
